import "./card.css";
import { AiOutlineArrowRight } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";

export const Card = ({ obj }) => {
    const dispatch = useDispatch();

    return (
        <NavLink to={`${obj.index}`} className="underline-none">
            <div className="servizio d-flex flex-column">
                <div className=" d-flex justify-content-center align-items-center pt-2">
                    <h3 className="text-center px-3 py-1 textBlue">{obj.title}</h3>
                </div>

                <div className="h-100">
                    <img className="cardImage p-3 h-100" src={obj.img} alt="title" />
                </div>
                <div className="d-flex justify-content-center">
                    <p className="textBlue">
                        Scopri di più <AiOutlineArrowRight />{" "}
                    </p>
                </div>
            </div>
        </NavLink>
    );
};
